import { call, put, select, takeLatest } from 'redux-saga/effects'

import { API_LANGUAGE_MAPPING } from '../../../../global/i18n/constants'
import { localeSelector } from '../../../../global/i18n/selectors'

import { setErrorMessage } from 'components/Windows/CentralMessagesList/reducer'
import { requireCinemaId } from 'components/Modal/CinemaSelectWindow/saga'
import { callApiAsync } from 'services/api/callAPIAsync'
import gtmMealVouchers from 'services/gtm/gtmMealVouchers'
import { loadSnacks, setSnacks } from './reducer'

function* getSnacksSaga() {
    const language = API_LANGUAGE_MAPPING?.[yield select(localeSelector)] ?? null
    const cinemaid = yield call(requireCinemaId)
    if (!cinemaid) return

    const { data, error } = yield call(callApiAsync, 'getVouchers', { language, using_type: 'M', cinemaid })
    if (error) {
        console.error(error)
        yield put(setErrorMessage('CANT_LOAD_MEAL_VOUCHERS_LIST'))
        return
    }

    gtmMealVouchers(data)
    yield put(setSnacks(data))
}

export default function* loadSnacksSaga() {
    yield takeLatest(loadSnacks.type, getSnacksSaga)
}
